
import React from "react";
import { Button } from "react-bootstrap";
import shareIcn from "../assets/images/TestShare-icon.png";
import liveLogo from '../assets/images/LiveTest-logo.png';

import minutesIcon1 from '../assets/images/minutes.png';
import questionIcon1 from '../assets/images/questn.png';
import marksIcon1 from '../assets/images/markk.png';
import testIcon3 from '../assets/images/test-icon3.png';
import DateRange from '../assets/images/timerRange.png';
import attemptedIcon from '../assets/images/test-icon1.png';

const DashboardTestCard = ({ item }) => {
  return (
    <div className="popularSeries-card dashboardCard">
      <div className="card itemCard">

        <div className="d-flex justify-content-between mb-2">
          <div className="d-flex gap-1">
            {item.logo && <img src={liveLogo} className="test-logo me-2" />}
            {item.free && <div className="text-white test-free fw-semibold">Free</div>}
            {item.live && <div className="liveTest fw-semibold">Live</div>}
          </div>

          {item.badgeShield && <img src={shareIcn} className="badge-logo"/>}
        </div>

        <h5 className="small blackText fw-bold">{item.title}</h5>

        <div className="d-flex align-items-center flex-wrap gap-2 grayText mb-2 font11 detailCard">
          <span className="font11"><img src={minutesIcon1} /> {item.duration}</span>
          <span className="font11"><img src={questionIcon1} /> {item.questions} Ques</span>
          <span className="font11"><img src={marksIcon1} /> {item.marks} Marks</span>
        </div>

        <div className="d-flex align-items-center flex-wrap gap-2 grayText mb-2 font11 series-attempts detailCard">
             {/* Attempted Section */}
            {item.attempted && (
                <span className="font11 attemptIcn">
                <img src={attemptedIcon} alt=""/> {item.attempted.toLocaleString()} Attempted
                </span>
            )}
            
         {/* Language Section */}
          <span className="font11"><img src={testIcon3} /> {item.languages.join(", ")}</span>
        </div>
   </div>
     <div className="testEnd">
        {item.timer && (
          <div className="text-danger small mt-2 mb-2">
            <span className="attempted-aspirants fw-medium font11"> Test will end in </span> <span className="ending-time fw-bold font11">{item.timer}</span>
          </div>
        )}

        {/* Attempted Aspirants */}

     {item.aspirantsCount && (
        <div className="text-secondary small mt-2 mb-2">
          <span className="attempted-aspirants fw-medium font11">
            Attempted by
          </span>{" "}
          <span className="attempted-aspirants fw-medium font11">
            {item.attemptedCount} aspirants
          </span>
        </div>
      )} 

        {/* DATE RANGE */}
  {item.dateRange && (
    <div className="d-flex align-items-center justify-content-center gap-2 mt-2 mb-2">
      <img 
        src={DateRange}  
        alt="Calendar" 
        width={11}
      />
      <span className="fw-semibold font11 blackText">
       <span className="greendateRange"> {item.dateRange.start} </span> To  <span className="greendateRange"> {item.dateRange.end} </span>
      </span>
    </div>
  )}

     </div>
        <div className="buttonALign">
        <Button variant="primary" className="w-100 btn-purple startNow fw-bold">
            {item.buttonLabel}
        </Button>
       </div>
      </div>
   
  );
}

export default DashboardTestCard;
